import { Box, Button, IconButton, alpha } from "@mui/material";
import {
  Mic as MicIcon,
  Stop as StopIcon,
  Send as SendIcon,
  Image as ImageIcon,
  InsertDriveFile as FileIcon,
} from "@mui/icons-material";
import { useContactCenterTheme } from "../../../virtual-receptionist/theming/ContactCenterThemeContext";

export const SenderButtons = ({
  canSend,
  uploadingMessage,

  isRecording,
  onStartRecording,
  onStopRecording,

  onSend,
  onFileClick,
  onImageClick,
}) => {
  const { theme } = useContactCenterTheme();

  return (
    <Box display="flex" alignItems="center" gap={0.5} px={1} pb={1} pt={0.5} width="100%">
      <IconButton
        size="small"
        onMouseDown={(event) => event.preventDefault()}
        onClick={onImageClick}
        disabled={uploadingMessage}
        aria-label="Attach image"
        sx={{ color: theme.shell.textSecondary }}
      >
        <ImageIcon fontSize="small" />
      </IconButton>

      <IconButton
        size="small"
        onMouseDown={(event) => event.preventDefault()}
        onClick={onFileClick}
        disabled={uploadingMessage}
        aria-label="Attach file"
        sx={{ color: theme.shell.textSecondary }}
      >
        <FileIcon fontSize="small" />
      </IconButton>

      <IconButton
        size="small"
        onMouseDown={(event) => event.preventDefault()}
        onClick={isRecording ? onStopRecording : onStartRecording}
        disabled={uploadingMessage}
        aria-label={isRecording ? "Stop recording" : "Record audio"}
        sx={{
          color: isRecording ? "error.main" : theme.shell.textSecondary,
          bgcolor: isRecording ? alpha("#d32f2f", 0.1) : "transparent",
        }}
      >
        {isRecording ? <StopIcon fontSize="small" /> : <MicIcon fontSize="small" />}
      </IconButton>

      <Box flex={1} />

      <Button
        variant="contained"
        size="small"
        onMouseDown={(event) => event.preventDefault()}
        onClick={onSend}
        disabled={!canSend}
        endIcon={<SendIcon fontSize="small" />}
        sx={{
          textTransform: "none",
          fontWeight: 600,
          px: 2,
          py: 0.75,
          borderRadius: 2,
          bgcolor: canSend ? theme.shell.accent : alpha(theme.shell.accent, 0.35),
          color: canSend ? "#fff" : alpha("#fff", 0.7),
          boxShadow: "none",
          "&:hover": {
            bgcolor: canSend ? theme.shell.accent : alpha(theme.shell.accent, 0.35),
            opacity: 0.88,
            boxShadow: "none",
          },
        }}
      >
        {uploadingMessage ? "..." : "Send"}
      </Button>
    </Box>
  );
};
